import React, { PropsWithChildren } from "react";
import { styled } from "@mui/material";

const Container = styled("footer")`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  padding: 20px;
  position: sticky;
  bottom: 0px;
  backdrop-filter: blur(24px);
  background-color: transparent;
  width: 100%;
  flex-grow: 1;
  align-content: flex-end;
  z-index: 1;
  justify-content: flex-end;
`;

// Sticky action section ( stick to bottom of the screen )
function StickyActionContainer({ children }: PropsWithChildren) {
  return <Container>{children}</Container>;
}

export default StickyActionContainer;
